<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="单号">
              <el-input v-model="q.applyno" placeholder="请输入单号" clearable/>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="q.status" placeholder="请选择状态" clearable style="width:100%">
                <el-option label="草稿" :value="0"/>
                <el-option label="待IT接口人审批" :value="1"/>
                <el-option label="待运维处理" :value="2"/>
                <el-option label="处理中" :value="3"/>
                <el-option label="已完成" :value="4"/>
                <el-option label="已驳回" :value="5"/>
              </el-select>
            </el-form-item>
            <el-form-item label="业务模块">
              <brselect v-model="q.businessModule" category="abnormal_business_module" placeholder="请选择" clearable/>
            </el-form-item>

            <el-form-item label="申请人">
              <el-input v-model="q.cuname" placeholder="请输入申请人" clearable/>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="handleReset">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="handleAdd">新增</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table :data="tableData" ref="table" stripe border style="width: 100%" v-loading="loading">
          <el-table-column prop="applyno" label="单号" fixed width="150">
            <template slot-scope="scope">
              <el-link type="primary" @click="handleView(scope.row)">{{scope.row.applyno}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="problemDesc" label="问题说明" min-width="300" show-overflow-tooltip/>
          <el-table-column prop="businessModule" label="业务模块" width="100">
<!--            <template slot-scope="scope">{{getBusinessModuleName(scope.row.businessModule)}}</template>-->
            <template slot-scope="scope">
                <dictname category="abnormal_business_module"  :v="scope.row.businessModule"/>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="scope">{{getStatusName(scope.row.status)}}</template>
          </el-table-column>
          <el-table-column prop="cuname" label="申请人" width="100"/>
          <el-table-column prop="cdate" label="创建时间" width="160">
            <template slot-scope="scope">{{formatDate(scope.row.cdate)}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="h-tableLink h-btn" @click="handleView(scope.row)">查看</el-button>
              <el-button v-if="scope.row.status === 0" type="text" size="small" class="h-tableLink h-btn" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.status === 0" type="text" size="small" class="h-tableLink h-btn" @click="handleSubmit(scope.row)">提交</el-button>
              <el-button v-if="scope.row.status === 5" type="text" size="small" class="h-tableLink h-btn" @click="handleResubmit(scope.row)">重新提交</el-button>
              <el-button v-if="[1,2,3].includes(scope.row.status)" type="text" size="small" class="h-tableLink h-btn" @click="handleWithdraw(scope.row)">撤回</el-button>
              <el-button v-if="scope.row.instid" type="text" size="small" class="h-tableLink h-btn" @click="handleTrack(scope.row)">跟踪</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" @click="handleExport" style="margin-left: 20px;">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--新增/编辑/重新提交弹窗-->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" class="h-dialog2 abnormal-dialog" width="700px" @close="cancelDialog">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{ dialogTitle }}</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="form" :rules="rules" ref="form" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
          <el-form-item label="单号" class="h-elformWrap-2">
            <el-input v-if="dialogMode === 'add'" disabled placeholder="提交后自动生成"/>
            <el-input v-else v-model="form.applyno" disabled/>
          </el-form-item>
          <el-form-item label="业务模块" class="h-elformWrap-2" prop="businessModule">
            <brselect :v="form.businessModule" v-model="form.businessModule" category="abnormal_business_module" placeholder="请选择业务模块" clearable/>
          </el-form-item>
          <el-form-item label="问题说明" class="h-elformWrap-1" prop="problemDesc">
            <el-input v-model="form.problemDesc" type="textarea" :rows="3" placeholder="请描述异常现象" style="border: #dedede 1px solid;"/>
          </el-form-item>
          <el-form-item label="期望修改内容" class="h-elformWrap-1" prop="expectContent">
            <el-input v-model="form.expectContent" type="textarea" :rows="3" placeholder="请描述期望修改的内容" style="border: #dedede 1px solid;"/>
          </el-form-item>
          <el-form-item label="申请附件" class="h-elformWrap-1">
            <brupload
              :refid="form.id || ''"
              reftype="abnormal_apply"
              :uploadflag="true"
              :delflag="true"
              @filecallback="handleFileCallback">
            </brupload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelDialog">取消</el-button>
        <el-button v-if="dialogMode !== 'resubmit'" class="h-btn h-formBtn h-bggreen" @click="handleSave">保存草稿</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleDialogSubmit">
          {{ dialogMode === 'resubmit' ? '重新提交' : '提交申请' }}
        </el-button>
      </div>
    </el-dialog>

    <!--查看详情弹窗-->
    <el-dialog :close-on-click-modal="false" :visible.sync="viewDialogVisible" class="h-dialog2 abnormal-dialog" width="700px">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>异常数据申请详情</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="viewForm" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms" disabled>
          <el-form-item label="单号" class="h-elformWrap-2">
            <el-input v-model="viewForm.applyno" disabled/>
          </el-form-item>
          <el-form-item label="状态" class="h-elformWrap-2">
            <el-input :value="getStatusName(viewForm.status)" disabled/>
          </el-form-item>
          <el-form-item label="业务模块" class="h-elformWrap-2">
            <dictname category="abnormal_business_module" :v="viewForm.businessModule"/>
          </el-form-item>
          <el-form-item label="申请人" class="h-elformWrap-2">
            <el-input v-model="viewForm.cuname" disabled/>
          </el-form-item>
          <el-form-item label="问题说明" class="h-elformWrap-1">
            <el-input v-model="viewForm.problemDesc" type="textarea" :rows="3" disabled style="border: #dedede 1px solid;"/>
          </el-form-item>
          <el-form-item label="期望修改内容" class="h-elformWrap-1">
            <el-input v-model="viewForm.expectContent" type="textarea" :rows="3" disabled style="border: #dedede 1px solid;"/>
          </el-form-item>
          <el-form-item v-if="viewForm.problemType" label="问题类型" class="h-elformWrap-2">
            <dictname category="abnormal_problem_type" :v="viewForm.problemType"/>
          </el-form-item>
          <el-form-item v-if="viewForm.solution" label="解决方案" class="h-elformWrap-1">
            <el-input v-model="viewForm.solution" type="textarea" :rows="3" disabled style="border: #dedede 1px solid;"/>
          </el-form-item>
          <el-form-item v-if="viewForm.receiveTime" label="接收时间" class="h-elformWrap-2">
            <el-input :value="formatDate(viewForm.receiveTime)" disabled/>
          </el-form-item>
          <el-form-item v-if="viewForm.completeTime" label="完成时间" class="h-elformWrap-2">
            <el-input :value="formatDate(viewForm.completeTime)" disabled/>
          </el-form-item>
          <el-form-item v-if="viewForm.ywHandlerName" label="运维处理人" class="h-elformWrap-2">
            <el-input v-model="viewForm.ywHandlerName" disabled/>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="viewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--审批流跟踪弹窗-->
    <viewhistory :visible.sync="showTrackDialog" v-if="showTrackDialog" :id="currentInstid"/>
  </div>
</template>

<script>
import ApplyService from '@/api/abnormal/ApplyService';

export default {
  data() {
    return {
      q: {
        applyno: '',
        status: null,
        businessModule: '',
        cuname: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      currentInstid: '',
      showTrackDialog: false,
      statusMap: {
        0: '草稿',
        1: '待IT接口人审批',
        2: '待运维处理',
        3: '处理中',
        4: '已完成',
        5: '已驳回'
      },
      dialogVisible: false,
      dialogMode: 'add',
      form: {
        id: '',
        applyno: '',
        businessModule: '',
        problemDesc: '',
        expectContent: '',
        fileIds: []
      },
      rules: {
        businessModule: [{ required: true, message: '请选择业务模块', trigger: 'change' }],
        problemDesc: [{ required: true, message: '请输入问题说明', trigger: 'blur' }],
        expectContent: [{ required: true, message: '请输入期望修改内容', trigger: 'blur' }]
      },
      viewDialogVisible: false,
      viewForm: {}
    };
  },
  computed: {
    dialogTitle() {
      if (this.dialogMode === 'add') return '新增异常数据申请';
      if (this.dialogMode === 'edit') return '编辑异常数据申请';
      if (this.dialogMode === 'resubmit') return '重新提交异常数据申请';
      return '异常数据申请';
    }
  },
  created() {
    this.loadData();
  },
  activated() {
    this.loadData();
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0') + ' ' +
        String(d.getHours()).padStart(2, '0') + ':' +
        String(d.getMinutes()).padStart(2, '0') + ':' +
        String(d.getSeconds()).padStart(2, '0');
    },
    getStatusName(status) {
      return this.statusMap[status] || '';
    },
    async loadData() {
      this.loading = true;
      try {
        const params = {
          ...this.q,
          pageNo: this.page.current,
          pageSize: this.page.size
        };
        const res = await ApplyService.page(params);
        this.tableData = res.records || [];
        this.page.total = res.total || 0;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    handleFilter() {
      this.page.current = 1;
      this.loadData();
    },
    handleReset() {
      this.q = {
        applyno: '',
        status: null,
        businessModule: '',
        cuname: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      };
      this.handleFilter();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.loadData();
    },
    handleAdd() {
      this.dialogMode = 'add';
      this.form = {
        id: '',
        applyno: '',
        businessModule: '',
        problemDesc: '',
        expectContent: '',
        fileIds: []
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleEdit(row) {
      this.dialogMode = 'edit';
      this.form = {
        id: row.id,
        applyno: row.applyno,
        businessModule: row.businessModule,
        problemDesc: row.problemDesc,
        expectContent: row.expectContent,
        fileIds: []
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleResubmit(row) {
      this.dialogMode = 'resubmit';
      this.form = {
        id: row.id,
        applyno: row.applyno,
        businessModule: row.businessModule,
        problemDesc: row.problemDesc,
        expectContent: row.expectContent,
        fileIds: []
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    async handleView(row) {
      this.$router.push({ path: '/abnormal/applyDetail', query: { id: row.id, mode: 'view' } });
    },
    handleFileCallback(files) {
      this.form.fileIds = files.map(f => f.id);
    },
    async handleSave() {
      try {
        await this.$refs.form.validate();
        const res = await ApplyService.save(this.form);
        if (res.f) {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.loadData();
        }
      } catch (e) {
        if (e !== false) {
          console.error(e);
        }
      }
    },
    async handleDialogSubmit() {
      try {
        await this.$refs.form.validate();
        let res;
        if (this.dialogMode === 'resubmit') {
          res = await ApplyService.resubmit(this.form);
        } else {
          res = await ApplyService.submit(this.form);
        }
        if (res.f) {
          this.$message({
            message: res.msg || '提交成功',
            type: 'success',
            duration: 3000
          });
          this.dialogVisible = false;
          this.loadData();
        } else {
          this.$message.error(res.msg || '提交失败');
        }
      } catch (e) {
        console.error(e);
      }
    },
    async handleSubmit(row) {
      try {
        const res = await ApplyService.submit({ id: row.id });
        if (res.f) {
          this.$message.success(res.msg || '提交成功');
          this.loadData();
        } else {
          this.$message.error(res.msg || '提交失败');
        }
      } catch (e) {
        console.error(e);
      }
    },
    async handleWithdraw(row) {
      try {
        await this.$confirm('确定要撤回该申请吗？', '提示', { type: 'warning' });
        const res = await ApplyService.withdraw(row.id);
        if (res.f) {
          this.$message.success(res.msg || '撤回成功');
          this.loadData();
        } else {
          this.$message.error(res.msg || '撤回失败');
        }
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e);
        }
      }
    },
    handleTrack(row) {
      this.currentInstid = row.instid;
      this.showTrackDialog = true;
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.$refs.form && this.$refs.form.resetFields();
    },
    handleExport() {
      ApplyService.exportExcel(this.q);
    }
  }
};
</script>
<style lang="less" scoped>
</style>
<style lang="less">
.abnormal-dialog .h-dialogImg {
  background-size: cover;
}
</style>
